module.exports = __webpack_public_path__ + "static/IMG_1667sm-f81ef3c6f9393ba9a1a35366c6357a0b.png";